import { Skeleton } from "@design";
import { useTranslation } from "react-i18next";

/**
 * AI is producing a reply but no text has arrived yet. Deliberately distinct
 * from a human TypingIndicator (shimmer lines, not dots).
 */
export function GeneratingIndicator() {
  const { t } = useTranslation("chat", { keyPrefix: "message" });
  return (
    <output aria-label={t("generating")} className="block max-w-[420px] space-y-1.5">
      <Skeleton variant="text" className="h-2 w-[88%]" />
      <Skeleton variant="text" className="h-2 w-[62%]" />
    </output>
  );
}
